module.exports = __webpack_public_path__ + "img/news_detail_3_1.58c3a2f9.png";